// import {
//   useInfiniteQuery,
//   useMutation,
//   useQuery,
//   useQueryClient,
// } from "@tanstack/react-query";
// import { useCore } from "hooks/useCore";
// import { useModal } from "hooks/useModal";
// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { createBranch, deleteBranch, getAllBranch } from "service/hf/branch";
// import { toast } from "sonner";
// import { getTokenFromLocalStore } from "utils";
// import { IFacilityRoles } from "../useLogin";

// export interface IAllBranchResponse {
//   count: number;
//   next: any | null;
//   previous: any | null;
//   results: IBranch[];
// }

// export interface IBranch {
//   pk: number;
//   name: string;
//   address: string;
//   lga: number;
//   location: number;
//   location_name: string;
//   health_facility: number;
//   home_service_fee: string | null;
//   service_type: string;
//   full_branch_name: string;
// }

// export interface ICreateHfFormData {
//   name: string;
//   address: string;
//   lga: string;
//   location: string | number;
// }

// export function useHfBranch() {
//   const { allStateData } = useCore();
//   const queryClient = useQueryClient();

//   const {
//     isOpen: addBranchIsOpen,
//     closeModal: addBranchClose,
//     openModal: addBranchOpen,
//   } = useModal();

//   const {
//     isOpen: deleteBranchIsOpen,
//     closeModal: deleteBranchClose,
//     openModal: deleteBranchOpen,
//   } = useModal();

//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);

//   const [branch, setBranch] = useState<IFacilityRoles | null>(null);
//   const [selectedBranch, setSelectedBranch] = useState<IBranch | null>(null);
//   const [formData, setFormData] = useState<ICreateHfFormData>({
//     name: "",
//     address: "",
//     lga: "",
//     location: "",
//   });

//   const params = useParams();
//   const navigate = useNavigate();

//   useEffect(() => {
//     const facilityRoles: IFacilityRoles[] =
//       getTokenFromLocalStore("facility_roles") || [];

//     if (facilityRoles.length > 0) {
//       const businessName = params.dynamic;
//       const branch = facilityRoles?.find((r) => r.hfSlug === businessName);
//       if (!branch) {
//         navigate("/not-found");
//       } else {
//         setBranch(branch);
//       }
//     }
//   }, [navigate, params]);

//   const {
//     data: allBranches,
//     isPending: allBranchesLoading,
//     error: allBranchesError,
//   } = useQuery<IAllBranchResponse>({
//     queryKey: ["hf-branches", branch?.hfId, page, pageSize],

//     queryFn: async () => {
//       if (!branch) return;
//       return getAllBranch(branch.hfId, page, pageSize);
//     },
//     enabled: !!branch,
//   });

//   const { mutate: createMutate, isPending: createIsPending } = useMutation({
//     mutationFn: async () => {
//       if (!branch) return;
//       const response = await createBranch(branch.hfId, formData);
//       return response;
//     },
//     onSuccess: async (data) => {
//       toast.success("Branch created successfully");
//       await queryClient.invalidateQueries({
//         queryKey: ["hf-branches", branch?.hfId],
//       });

//       addBranchClose();
//       setFormData({
//         name: "",
//         address: "",
//         lga: "",
//         location: "",
//       });
//     },
//     onError: (error: any) => {
//       const errors = error.response?.data.errors;

//       if (Array.isArray(errors)) {
//         const errorMessages = errors.map((err) => err.detail).join(", ");
//         toast.error(errorMessages);
//       } else {
//         toast.error("An unknown error occurred.");
//       }
//     },
//   });

//   const { mutate: deleteMutate, isPending: deleteIsPending } = useMutation({
//     mutationFn: async () => {
//       if (!branch || !selectedBranch) return;
//       const response = await deleteBranch(branch.hfId, selectedBranch.pk);
//       return response;
//     },
//     onSuccess: async (data) => {
//       toast.success("Branch deleted successfully");
//       await queryClient.invalidateQueries({
//         queryKey: ["hf-branches", branch?.hfId],
//       });

//       deleteBranchClose();
//       setSelectedBranch(null);
//     },
//     onError: (error: any) => {
//       const errors = error.response?.data.errors;

//       if (Array.isArray(errors)) {
//         const errorMessages = errors.map((err) => err.detail).join(", ");
//         toast.error(errorMessages);
//       } else {
//         toast.error("An unknown error occurred.");
//       }
//     },
//   });

//   const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const { name, value } = event.target;
//     setFormData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   const handleFieldChange = (
//     field: keyof ICreateHfFormData,
//     value: string | number | boolean
//   ) => {
//     setFormData((prevState) => ({
//       ...prevState,
//       [field]: value,
//       ...(field === "location" && { lga: "" }),
//     }));
//   };

//   const handleCreate = () => {
//     createMutate();
//   };

//   const handleDelete = () => {
//     deleteMutate();
//   };

//   const isFormComplete = () => {
//     return (
//       formData.name && formData.address && formData.lga && formData.location
//     );
//   };

//   const handleTableChange = (pagination: any) => {
//     console.log(pagination);
//     setPage(pagination.current);
//     setPageSize(pagination.pageSize);
//   };

//   const allStateOption = allStateData?.results.map((state) => ({
//     label: state.name,
//     value: state.pk,
//   }));

//   const selectedState = allStateData?.results.find(
//     (state) => state.pk === formData.location
//   );

//   const allLgaOption =
//     selectedState?.lgas.map((lga) => ({
//       label: lga.name,
//       value: lga.pk,
//     })) || [];

//   const allBranchesOptions = allBranches?.results.map((branch) => ({
//     label: branch.name,
//     value: branch.pk,
//   }));

//   return {
//     branch,
//     allBranches,
//     isLoading: allBranchesLoading || createIsPending || deleteIsPending,
//     error: allBranchesError,
//     formData,
//     createIsPending,
//     allStateOption,
//     allLgaOption,
//     addBranchIsOpen,
//     allBranchesOptions,
//     selectedBranch,
//     deleteBranchIsOpen,
//     pageSize,
//     page,
//     handleTableChange,
//     deleteBranchClose,
//     handleDelete,
//     handleInputChange,
//     handleFieldChange,
//     handleCreate,
//     isFormComplete,
//     addBranchClose,
//     deleteBranchOpen,
//     addBranchOpen,
//     setSelectedBranch,
//   };
// }


import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { useCore } from "hooks/useCore";
import { useModal } from "hooks/useModal";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createBranch, deleteBranch, getAllBranch } from "service/hf/branch";
import { toast } from "sonner";
import { getTokenFromLocalStore } from "utils";
import { IFacilityRoles } from "../useLogin";

export interface IAllBranchResponse {
  count: number;
  next: any | null;
  previous: any | null;
  results: IBranch[];
}

export interface IBranch {
  pk: number;
  name: string;
  address: string;
  lga: number;
  location: number;
  location_name: string;
  health_facility: number;
  home_service_fee: string | null;
  service_type: string;
  full_branch_name: string;
}

export interface ICreateHfFormData {
  name: string;
  address: string;
  lga: string;
  location: string | number;
}

export interface IHfLocationResult {
  id: number;
  name_of_facility: string;
  address: string;
  email: string;
  phone: string;
  opening_hour: string;
  closing_hour: string;
  logo: string;
  is_active: boolean;
  location: string;
  lga: string;
  service_type: string;
  home_service_fee: string;
}

export function useHfBranch() {
  const { allStateData } = useCore();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const params = useParams();

  const {
    isOpen: addBranchIsOpen,
    closeModal: addBranchClose,
    openModal: addBranchOpen,
  } = useModal();

  const {
    isOpen: deleteBranchIsOpen,
    closeModal: deleteBranchClose,
    openModal: deleteBranchOpen,
  } = useModal();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [branch, setBranch] = useState<IFacilityRoles | null>(null);
  const [selectedBranch, setSelectedBranch] = useState<IBranch | null>(null);
  const [formData, setFormData] = useState<ICreateHfFormData>({
    name: "",
    address: "",
    lga: "",
    location: "",
  });

  useEffect(() => {
    const facilityRoles: IFacilityRoles[] = getTokenFromLocalStore("facility_roles") || [];
    const businessName = params.dynamic;

    if (!facilityRoles.length) {
      toast.error("Please log in to access facility data.");
      navigate("/login");
      return;
    }

    if (!businessName) {
      setBranch(null);
      return;
    }

    const foundBranch = facilityRoles.find((r) => r.hfSlug === businessName);

    if (!foundBranch) {
      toast.error("Facility not found. Please check the URL or log in again.");
      navigate("/not-found");
      return;
    }

    setBranch(foundBranch);
  }, [navigate, params]);

  const {
    data: allBranches,
    isPending: allBranchesLoading,
    error: allBranchesError,
  } = useQuery<IAllBranchResponse>({
    queryKey: ["hf-branches", branch?.hfId, page, pageSize],
    queryFn: async () => {
      if (!branch?.hfId) {
        throw new Error("No branch ID available");
      }
      return getAllBranch(branch.hfId, page, pageSize);
    },
    enabled: !!branch?.hfId,
  });

  const { mutate: createMutate, isPending: createIsPending } = useMutation({
    mutationFn: async () => {
      if (!branch?.hfId) {
        throw new Error("No branch ID available");
      }
      return createBranch(branch.hfId, formData);
    },
    onSuccess: async () => {
      toast.success("Branch created successfully");
      await queryClient.invalidateQueries({
        queryKey: ["hf-branches", branch?.hfId],
      });
      addBranchClose();
      setFormData({
        name: "",
        address: "",
        lga: "",
        location: "",
      });
    },
    onError: (error: any) => {
      let errorMessage = "Failed to create branch.";
      if (error.response?.data?.errors) {
        const errors = error.response.data.errors;
        if (Array.isArray(errors)) {
          errorMessage = errors.map((err) => err.detail).join(", ");
        } else {
          errorMessage = errors;
        }
      }
      toast.error(errorMessage);
    },
  });

  const { mutate: deleteMutate, isPending: deleteIsPending } = useMutation({
    mutationFn: async () => {
      if (!branch?.hfId || !selectedBranch?.pk) {
        throw new Error("No branch or selected branch ID available");
      }
      return deleteBranch(branch.hfId, selectedBranch.pk);
    },
    onSuccess: async () => {
      toast.success("Branch deleted successfully");
      await queryClient.invalidateQueries({
        queryKey: ["hf-branches", branch?.hfId],
      });
      deleteBranchClose();
      setSelectedBranch(null);
    },
    onError: (error: any) => {
      console.log("Delete Branch Error:", error.response?.data);
      let errorMessage = "Failed to delete branch.";
      if (error.response?.data?.errors) {
        const errors = error.response.data.errors;
        if (Array.isArray(errors)) {
          errorMessage = errors.map((err) => err.detail).join(", ");
        } else {
          errorMessage = errors;
        }
      }
      toast.error(errorMessage);
    },
  });

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleFieldChange = (
    field: keyof ICreateHfFormData,
    value: string | number | boolean
  ) => {
    setFormData((prevState) => ({
      ...prevState,
      [field]: value,
      ...(field === "location" && { lga: "" }),
    }));
  };

  const handleCreate = () => {
    if (!isFormComplete()) {
      toast.error("Please complete all fields");
      return;
    }
    createMutate();
  };

  const handleDelete = () => {
    if (!selectedBranch) {
      toast.error("No branch selected");
      return;
    }
    deleteMutate();
  };

  const isFormComplete = () => {
    return (
      formData.name && formData.address && formData.lga && formData.location
    );
  };

  const handleTableChange = (pagination: any) => {
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const allStateOption = allStateData?.results.map((state) => ({
    label: state.name,
    value: state.pk,
  }));

  const selectedState = allStateData?.results.find(
    (state) => state.pk === formData.location
  );

  const allLgaOption =
    selectedState?.lgas.map((lga) => ({
      label: lga.name,
      value: lga.pk,
    })) || [];

  const allBranchesOptions = allBranches?.results.map((branch) => ({
    label: branch.name,
    value: branch.pk,
  }));

  return {
    branch,
    allBranches,
    isLoading: allBranchesLoading || createIsPending || deleteIsPending,
    error: allBranchesError,
    formData,
    createIsPending,
    allStateOption,
    allLgaOption,
    addBranchIsOpen,
    allBranchesOptions,
    selectedBranch,
    deleteBranchIsOpen,
    pageSize,
    page,
    handleTableChange,
    deleteBranchClose,
    handleDelete,
    handleInputChange,
    handleFieldChange,
    handleCreate,
    isFormComplete,
    addBranchClose,
    deleteBranchOpen,
    addBranchOpen,
    setSelectedBranch,
  };
}